export const cartHayadataTexts = {
  title_bold: " הידעת? ",
  title_regular: " למה אין כפתור לתשלום? ",
  description:
    "חשוב לנו שההזמנה תהיה גמישה לשינויים ועריכה עד זמן הסגירה וכדי לא ליצור מצב ששיניתם משהו ובגלל ששכחתם ללחוץ שוב על כפתור התשלום כל ההזמנה לא תגיע וחבל.לכן כל מוצר שתכניסו להזמנה נשמר והתשלום מתבצע בצורה אוטומטית סמוך להספקה כך גם נוכל להמנע מגביה מיותרת על מוצרים שלא סופקו.",
};
